import { useLocation } from 'react-router-dom';
import ReviewPage from '../../shared/booking/ReviewPage';
import { ExpiredSelection } from '../../shared/booking/FlowParts';
import SightseeingSummary from './SightseeingSummary';

export default function SightseeingReview() {
  const { state } = useLocation();
  if (!state?.summary) return <ExpiredSelection module="sightseeing" />;

  const { summary, backTo } = state;
  const { adults, children, adultPrice, childPrice } = summary;
  const base = adultPrice * adults + childPrice * children;

  return (
    <ReviewPage
      module="sightseeing"
      heading="Review your activity"
      back={{ to: backTo, label: 'Change option' }}
      summary={<SightseeingSummary summary={summary} />}
      info={[
        'Your mobile voucher will be emailed instantly — show it at the venue.',
        'Please arrive 15 minutes before your time slot.',
        'Free cancellation up to 24 hours before the activity.',
      ]}
      travellers={[{ type: 'Adult', label: 'Lead traveller', note: 'Voucher will be issued in this name', fields: ['title', 'firstName', 'lastName'] }]}
      fareLines={[
        [`${summary.optionName} — Adult × ${adults}`, adultPrice * adults],
        ...(children ? [[`${summary.optionName} — Child × ${children}`, childPrice * children]] : []),
        ['Taxes & fees', Math.round(base * 0.05), 'tax'],
      ]}
      buildBooking={() => ({
        title: summary.title,
        subtitle: `${summary.city} · ${adults + children} participant${adults + children > 1 ? 's' : ''} · ${summary.slot}`,
        travelDate: summary.date,
        summary,
      })}
    />
  );
}
